import { FilterInput, FilterType, FilterViewModel } from 'types/Search';

function getActiveFilters(filter: FilterViewModel): string[] {
  switch (filter.type) {
    case FilterInput.CHECKBOX:
    case FilterInput.RADIO:
      // The active state for Sort is only set when not using the application default choice.
      if (filter.key === FilterType.SORT && 'best-match' in filter.config && filter.config['best-match'].selected) {
        return [];
      }

      return Object.values(filter.config)
        .filter(config => config.selected)
        .map(config => config.name) as string[];
    case FilterInput.SLIDER:
      // The slider is using the default value.
      if (filter.config.displayValue === filter.config.upperBound) {
        return [];
      }
      return [filter.display];
    case FilterInput.RANGE:
      // The range is using the default values.
      if (filter.config.displayValue[0] === 0 && filter.config.displayValue[1] === filter.config.upperBound) {
        return [];
      }
      return [filter.display];
    case FilterInput.STAR_RATING:
      return filter.config !== null ? [filter.display] : [];
    default:
      // eslint-disable-next-line no-console
      console.warn(`getActiveFilters unexpected filter type: ${JSON.stringify(filter)}`);
      return [];
  }
}

function getAllAppliedFilterLabels(appliedByKey: Record<string, FilterViewModel>): Record<string, string[]> {
  return Object.values(appliedByKey).reduce(
    (memo, nextFilter) => ({
      ...memo,
      [nextFilter.key]: getActiveFilters(nextFilter)
    }),
    {}
  );
}

function getLabelsForKeys(keys: string[], labels: Record<string, string[]>) {
  return keys.reduce((memo, nextKey) => {
    if (labels[nextKey]?.length > 0) {
      memo.push(...labels[nextKey]);
    }

    return memo;
  }, []);
}

export { getAllAppliedFilterLabels, getLabelsForKeys };
